



















import { Component, Prop, Vue } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'

interface Option {
	key: string
	value: string
}
@Component({
	components: {
		Multiselect,
	},
})
export default class Select extends Vue {
	@Prop() public value !: any
	@Prop({ default: false }) public multi!: boolean
	@Prop() public label!: string
	@Prop() public options!: Option[]

	private selection: any = null

	private created() {
		console.log(this.options)
		if (this.multi) {
			this.selection = []
			if (!this.value) {
				return
			}
			this.value.forEach((selected) => {
				const foundSelection = this.options.find((item: Option) => item.key === selected)
				if (foundSelection) {
					this.selection.push(foundSelection)
				}
			})
			return
		}
		this.selection = this.options.find((item: Option) => item.key === this.value)
	}

	private get placeholderText() {
		if (this.multi) {
			return 'Select options'
		}
		return 'Select an option'
	}

	private updateValue(value: any) {
		if (this.multi) {
			const updatedValues: string[] = []
			this.selection.forEach((selected: Option) => {
				updatedValues.push(selected.key)
			})
			this.$emit('input', updatedValues)
			return
		}
		if (value) {
			this.$emit('input', value.key)
		}
	}
}
